import { render, staticRenderFns } from "./formTransportSupply.vue?vue&type=template&id=08d10b29&scoped=true"
import script from "./formTransportSupply.vue?vue&type=script&lang=js"
export * from "./formTransportSupply.vue?vue&type=script&lang=js"
import style0 from "./formTransportSupply.vue?vue&type=style&index=0&id=08d10b29&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d10b29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d10b29')) {
      api.createRecord('08d10b29', component.options)
    } else {
      api.reload('08d10b29', component.options)
    }
    module.hot.accept("./formTransportSupply.vue?vue&type=template&id=08d10b29&scoped=true", function () {
      api.rerender('08d10b29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/order/components/form/steps/formTransportSupply.vue"
export default component.exports